<template>
  <div id="form-creation-field-information">
    <Input
      class="scs-input"
      heading="Field Title"
      :initialValue="field.name"
      :error="errors.field.name"
      placeholder="Field Title"
      @scs-input="fieldTitleInput"
    />
    <toggle
      heading="User May Duplicate"
      @toggle="fieldDuplicableInput"
      :selected="field.duplicable"
      :option1="false"
      :option2="true"
    />
    <toggle
      heading="Library Enabled"
      @toggle="fieldLibraryInput"
      :selected="field.libraryEnabled"
      :option1="false"
      :option2="true"
    />
    <Input
      v-if="!field.libraryEnabled"
      class="scs-input"
      heading="Number of Inputs"
      placeholder="Number of Inputs"
      :error="errors.field.inputQuantity"
      :initialvalue="field.fields.length"
      type="number"
      @scs-input="inputQuantityInput"
    />
  </div>
</template>
<script>
import Input from "@/Components/Elements/Input.vue";
import Toggle from "@/Components/Elements/Binary.vue";
export default {
  methods: {
    fieldTitleInput(value) {
      this.$emit("field-title-input", value);
    },
    fieldDuplicableInput(value) {
      this.$emit("field-duplicable-input", Boolean(value));
    },
    fieldLibraryInput(value) {
      this.$emit("field-library-input", Boolean(value));
    },
    inputQuantityInput(value) {
      if (isNaN(parseInt(value))) {
        return;
      } else {
        this.$emit("input-quantity-input", parseInt(value));
      }
    },
  },
  components: {
    Input,
    Toggle,
  },
  emits: [
    "field-title-input",
    "field-duplicable-input",
    "field-library-input",
    "input-quantity-input",
  ],
  props: ["field", "errors"],
};
</script>
<style scoped>
@media screen {
  #form-creation-field-information {
    min-height: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
  }

  .scs-input {
    margin: 10px;
  }

  @media (min-width: 800px) {
    .scs-input {
      width: 350px;
    }
  }
}
</style>
